module.exports = __webpack_public_path__ + "static/img/SEED.d39624b3.png";